import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {CommonModule} from '@angular/common';
import { FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { Select } from 'primeng/select';
import { DatePicker } from 'primeng/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../_utility';
import { BreadcrumbsService } from '../../_components/breadcrumbs/breadcrumbs.service';
import { ApiService } from '../../_services';
import { Restaurant } from '../../_models/Restaurant';
import { RestaurantSlot } from '../../_models/RestaurantSlot';
import { ConfirmDialogComponent } from '../../_components/confirm-dialog/confirm-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { DuplicateSlotsDialogComponent } from '../../_components/duplicate-slots-dialog/duplicate-slots-dialog.component';
import { DateTime } from 'luxon';
import { forkJoin, take } from 'rxjs';

@Component({
  selector: 'app-slot-management',
  templateUrl: './slot-management.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, Tooltip, Select, DatePicker, FormsModule, TranslateModule],
})
export class SlotManagementComponent implements OnInit {
  form!: FormGroup;
  Restaurants: Array<Restaurant> = [];
  selectedRestaurant!: Restaurant;
  date: Date | undefined;
  slots: Array<RestaurantSlot> = [];
  public retentionDate: Date = new Date(
    new Date().setDate(new Date().getDate() - Constants.RETENTION_WINDOW)
  );
  public slotLoaded: boolean = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private breadcrumb: BreadcrumbsService,
    private apiService: ApiService,
    public dialog: DialogService,
    private spinner: SpinnerService,
    public translate: TranslateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.GESTIONE_SLOT.path);
    }, 200);
    this.spinner.show();

    forkJoin({
      restaurants: this.apiService.Restaurants(),
      params: this.route.queryParams.pipe(take(1)),
    }).subscribe({
      next: ({ restaurants, params }) => {
        let idRestaurant = '';
        let previousDate = '';
        if (params) {
          idRestaurant = params['restaurantId'];
          previousDate = params['date'];
        }
        this.Restaurants = restaurants;
        if (idRestaurant != '' && previousDate != '') {
          const matchedRestaurant = this.Restaurants.find(
            (restaurant) => restaurant.id_restaurant.toString() === idRestaurant
          );

          if (matchedRestaurant) {
            this.selectedRestaurant = matchedRestaurant;
            this.date = new Date(previousDate);
            this.GetSlots();
          }
        }
        this.spinner.hide();
      },
      error: (error) => {
        console.error(error);
        this.spinner.hide();
      },
    });
  }
  ResetForm() {
    this.date = undefined;
    this.slots = [];
  }

  GetSlots() {
    this.spinner.show();
    let formattedDate = DateTime.fromJSDate(this.date!).toSQLDate();
    this.apiService
      .Slots(this.selectedRestaurant.id_restaurant, formattedDate!)
      .subscribe({
        next: (data) => {
          this.slots = data;
          this.slotLoaded = true;
          this.spinner.hide();
        },
        error: (error) => {
          console.error(error);
          this.spinner.hide();
        },
      });
  }

  Back() {
    this.goTo('restaurant_management');
  }

  prevDate() {
    this.date = DateTime.fromJSDate(this.date!).minus({ days: 1 }).toJSDate();
    this.GetSlots();
  }

  succDate() {
    this.date = DateTime.fromJSDate(this.date!).plus({ days: 1 }).toJSDate();
    this.GetSlots();
  }

  GoToAdd() {
    this.router.navigate(Constants.Routing.MODIFICA_SLOT.routerLink, {
      queryParams: {
        restaurantId: this.selectedRestaurant.id_restaurant,
        date: DateTime.fromJSDate(this.date!).toSQLDate(),
      },
    });
  }

  GoToEdit(id_restaurant_slot: string, has_booked_table: number) {
    let obj = {
      resturant: this.selectedRestaurant,
      date: this.date,
    };

    if (has_booked_table === 1) {
      const ref = this.dialog.open(ConfirmDialogComponent, {
        styleClass: 'resizableDialog',
        header: this.translate.instant('slot_management.edit_slot'),
        width: '50vw',
        modal: true,
        closable: true,
        data: {
          flag: 'edit_slot',
        },
      });

      ref?.onClose.subscribe((o: any) => {
        if (o) {
          this.router.navigate(Constants.Routing.MODIFICA_SLOT.routerLink, {
            queryParams: {
              restaurantId: this.selectedRestaurant.id_restaurant,
              restaurantSlotId: id_restaurant_slot,
            },
          });
        }
      });
    } else {
      this.router.navigate(Constants.Routing.MODIFICA_SLOT.routerLink, {
        queryParams: {
          restaurantId: this.selectedRestaurant.id_restaurant,
          restaurantSlotId: id_restaurant_slot,
        },
      });
    }
  }

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'restaurant_management': {
        this.router.navigate(Constants.Routing.HOME_RISTORANTI.routerLink);
        // this.session_storage.removeElement(Constants.Storager.RESTURANT);
        break;
      }
    }
  }
  deleteSlot(slot: RestaurantSlot) {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      styleClass: 'resizableDialog',
      header: this.translate.instant('confirm_dialog.delete_slot_title'),
      width: '50vw',
      modal: true,
      closable: true,
      data: {},
    });

    ref?.onClose.subscribe((o: any) => {
      if (o) {
        this.spinner.show();
        this.apiService
          .DeleteSlot(
            slot.fk_restaurant.toString(),
            slot.id_restaurant_slot.toString()
          )
          .subscribe({
            next: (data) => {
              this.GetSlots();
              this.spinner.hide();
            },
            error: (error) => {
              console.error(error);
              this.spinner.hide();
            },
          });
      }
    });
  }

  DuplicateSlot(slot: RestaurantSlot) {
    const ref = this.dialog.open(DuplicateSlotsDialogComponent, {
      styleClass: 'resizableDialog',
      header: this.translate.instant('confirm_dialog.duplicate_slot_title'),
      width: '50vw',
      modal: true,
      closable: true,
      data: {
        slot: slot,
        duplicateType: 'single',
        id_restaurant: this.selectedRestaurant.id_restaurant,
      },
    });

    ref?.onClose.subscribe({
      next: (o: any) => {},
    });
  }

  DuplicateDay() {
    const ref = this.dialog.open(DuplicateSlotsDialogComponent, {
      styleClass: 'resizableDialog',
      header: this.translate.instant('confirm_dialog.duplicate_daty_title'),
      width: '50vw',
      modal: true,
      closable: true,
      data: {
        date: this.date,
        duplicateType: 'multiple',
        id_restaurant: this.selectedRestaurant.id_restaurant,
      },
    });
    ref?.onClose.subscribe({
      next: (o: any) => {},
    });
  }
}
